import ApplicationsDataAnswered from './ApplicationsDataAnswered';
import ApplicationsQuestion from './ApplicationsQuestion';
import ApplicationsSettingsLoader from '@core/classes/Applications/ApplicationsSettingsLoader';

import util from '@core/services/util';

export default class ApplicationsQuoteAppData {
	constructor(init) {
		let questionList = this.ApplicationsSettings()?.questionList ?? [];

		if (init.quoteAppData) {
			this.questions = questionList.map(q => {
				if (init.quoteAppData.pathFollowed.some(pq => pq == q.key) || init.quoteAppData.currentQuestion == q.key) {
					q.savedAnswer = util.getPropValueRaw(init, q.dataStructurePath);
				}
				return new ApplicationsQuestion({
					question: q,
					customerApp: init.customerApp,
				});
			});
			this.pathFollowed = init.quoteAppData.pathFollowed; // List with the keys of all answered questions
			this.language = init.quoteAppData.language; // Possible Values: English, Spanish
			this.summary = init.quoteAppData.summary;
			this.currentQuestion = init.quoteAppData.currentQuestion;
			this.applicationsDataAnswered = new ApplicationsDataAnswered(init.quoteAppData.applicationsDataAnswered);
		} else {
			this.questions = questionList.map(
				q =>
					new ApplicationsQuestion({
						question: q,
						customerApp: init.customerApp,
					}),
			);
			this.pathFollowed = [];
			this.language = 'English';
			this.summary = '';
			this.currentQuestion = 'providePrefix';
			this.applicationsDataAnswered = new ApplicationsDataAnswered();
		}
	}

	getSanitizedData() {
		let sanitizedData = new ApplicationsQuoteAppData({ quoteAppData: this });
		sanitizedData.questions = null;

		return sanitizedData;
	}

	ApplicationsSettings() {
		return ApplicationsSettingsLoader.ApplicationSettings;
	}

	changeLanguage(language) {
		this.language = language;
	}
}
